/**
 * Announcement Bar Rotation Script
 * Handles left/right arrow navigation and auto-rotation
 */

(function() {
  'use strict';
  
  // Configuration
  const AUTO_ROTATE_DELAY = 5000; // Change message every 5 seconds (5000ms)
  const ENABLE_AUTO_ROTATE = true; // Set to false to disable auto-rotation
  
  // Get elements
  const messages = document.querySelectorAll('.announcement-message');
  const leftArrow = document.querySelector('.announcement-arrow-left');
  const rightArrow = document.querySelector('.announcement-arrow-right');
  const closeBtn = document.querySelector('.announcement-close');
  
  if (!messages.length) return;
  
  let currentIndex = 0;
  let autoRotateInterval;
  
  // Show specific message
  function showMessage(index) {
    messages.forEach((msg, i) => {
      if (i === index) {
        msg.classList.add('active');
      } else {
        msg.classList.remove('active');
      }
    });
    currentIndex = index;
  }
  
  // Next message
  function nextMessage() {
    const nextIndex = (currentIndex + 1) % messages.length;
    showMessage(nextIndex);
  }
  
  // Previous message
  function previousMessage() {
    const prevIndex = (currentIndex - 1 + messages.length) % messages.length;
    showMessage(prevIndex);
  }
  
  // Start auto-rotation
  function startAutoRotate() {
    if (ENABLE_AUTO_ROTATE && messages.length > 1) {
      autoRotateInterval = setInterval(nextMessage, AUTO_ROTATE_DELAY);
    }
  }
  
  // Stop auto-rotation
  function stopAutoRotate() {
    if (autoRotateInterval) {
      clearInterval(autoRotateInterval);
    }
  }
  
  // Arrow click handlers
  if (leftArrow) {
    leftArrow.addEventListener('click', () => {
      stopAutoRotate();
      previousMessage();
      startAutoRotate();
    });
  }
  
  if (rightArrow) {
    rightArrow.addEventListener('click', () => {
      stopAutoRotate();
      nextMessage();
      startAutoRotate();
    });
  }
  
  // Close button handler (if enabled)
  if (closeBtn) {
    closeBtn.addEventListener('click', () => {
      const announcementBar = document.querySelector('.announcement-bar');
      if (announcementBar) {
        announcementBar.style.display = 'none';
        stopAutoRotate();
        // Optional: Save to localStorage so it stays closed
        localStorage.setItem('announcementBarClosed', 'true');
      }
    });
  }
  
  // Hide arrows if only one message
  if (messages.length === 1) {
    if (leftArrow) leftArrow.style.display = 'none';
    if (rightArrow) rightArrow.style.display = 'none';
  }
  
  // Check if announcement bar was previously closed
  const wasClosed = localStorage.getItem('announcementBarClosed');
  if (wasClosed === 'true') {
    const announcementBar = document.querySelector('.announcement-bar');
    if (announcementBar) {
      announcementBar.style.display = 'none';
    }
  } else {
    // Start auto-rotation
    startAutoRotate();
  }
  
})();